import { api } from "../api";
const defaultRouteName = "/acfaz/emissao";

export const enviarSenhaEmissao = (idSolicitacao) =>
  api.post(`${defaultRouteName}/senha/${idSolicitacao}`);
